import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorsConstants } from '../../common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dashboard-card-with-title',
  standalone: true,
  imports: [CommonModule , MatIconModule],
  templateUrl: './dashboard-card-with-title.component.html',
  styleUrls: ['./dashboard-card-with-title.component.scss'],
})
export class DashboardCardWithTitleComponent implements OnInit {
  // inputs
  @Input() headerImage: string;
  @Input() headerIcon: string;
  @Input() headerIconColor: string = ColorsConstants.PRIMARY_COLOR;
  @Input() headerTitle: string;
  @Input() backgroundColor: string = ColorsConstants.LIGHT_COLOR;

  constructor() {}

  ngOnInit(): void {}
}
